import type { Category } from '@/models';
import type { NnnInstrumentOptionGroup } from '../types/careplan-nnn.types';

export function buildInstrumentOptionGroups(categories: Category[]): NnnInstrumentOptionGroup[] {
  return [...categories]
    .sort((a, b) => a.order - b.order)
    .map(category => {
      const byId = new Map<string, { id: string; title: string }>();
      for (const categoryAppFunction of [...category.categoryAppFunctions].sort((a, b) => a.order - b.order)) {
        const { id, title } = categoryAppFunction.appFunction;
        if (!byId.has(id)) {
          byId.set(id, { id, title });
        }
      }
      return {
        id: category.id,
        name: category.name,
        functions: [...byId.values()],
      };
    })
    .filter(group => group.functions.length > 0);
}
